var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.materialTypeLabel))]), _vm._v(" "), _vm._l(_vm.getDisplayFields, function (displayField) {
    return _c('FieldDisplay', {
      key: displayField.name,
      attrs: {
        "display-field": displayField,
        "individual-field-data": _vm.bioMaterial[displayField.name]
      }
    });
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }